import { useMemo } from 'react'
import { usePRFile } from '@sketch-hq/sketch-web-renderer'
import { buildSketchSceneTreeFromPRFile } from './sketchSceneLib/buildSketchScene/buildSketchSceneTree'

/**
 * Build the tree of sketch elements from the PR file from the web-renderer.
 * The PR file contains the rendering node from which we reconstruct
 * the tree of layers like what we show to users in the Sketch app.
 */
export function useSketchSceneTree() {
  const prFile = usePRFile()

  return useMemo(() => {
    if (!prFile) {
      return null
    }
    const sketchRootElement = buildSketchSceneTreeFromPRFile(prFile)

    return sketchRootElement
  }, [prFile])
}
